import { categoriesData, projectsData, publicUrl } from "../content";

const withImages = (item) => {
  const images = (item.images || []).map(publicUrl);
  return { ...item, images, coverImage: images[0] };
};

export const projects = projectsData.items.map(withImages);

export const categories = categoriesData.items.map((item) => item.id);

export const categoryLabels = Object.fromEntries(categoriesData.items.map((item) => [item.id, item.label]));

export const projectById = Object.fromEntries(projects.map((item) => [item.id, item]));

export const projectsByCategory = (category) => projects.filter((item) => item.category === category);

export const projectGroups = projects.reduce((groups, project) => {
  if (!project.featureGroup) return groups;
  groups[project.featureGroup] = [...(groups[project.featureGroup] || []), project];
  return groups;
}, {});
